export class PeriodoEjercicioAnualModel {
  dia: number = 0;
  mes: number = 0;

  constructor() { }
}
